const Member = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49H9.17C10.3994 11.449 11.5646 10.9315 12.4193 10.0469C13.274 9.16234 13.7512 7.98004 13.75 6.75C13.75 4.13 11.62 2 9 2Z"
        fill="#C1C1C1"
      />
      <path
        opacity="0.4"
        d="M14.08 14.149C11.29 12.289 6.73999 12.289 3.92999 14.149C2.65999 14.999 1.95999 16.149 1.95999 17.379C1.95999 18.609 2.65999 19.749 3.91999 20.589C5.31999 21.529 7.15999 21.999 8.99999 21.999C10.84 21.999 12.68 21.529 14.08 20.589C15.34 19.739 16.04 18.599 16.04 17.359C16.03 16.129 15.34 14.989 14.08 14.149Z"
        fill="#C1C1C1"
      />
      <path
        opacity="0.4"
        d="M19.99 7.338C20.15 9.278 18.77 10.978 16.86 11.208H16.81C16.75 11.208 16.69 11.208 16.64 11.228C15.67 11.278 14.78 10.968 14.11 10.398C15.14 9.478 15.73 8.098 15.61 6.598C15.5414 5.818 15.2765 5.06806 14.84 4.418C15.364 4.16308 15.9421 4.03947 16.5245 4.05782C17.1069 4.07617 17.6762 4.23595 18.1831 4.52335C18.69 4.81076 19.1193 5.21717 19.4341 5.70753C19.7489 6.19789 19.9397 6.75747 19.99 7.338Z"
        fill="#C1C1C1"
      />
      <path
        d="M21.988 16.59C21.908 17.56 21.288 18.4 20.248 18.97C19.248 19.52 17.988 19.78 16.738 19.75C17.458 19.1 17.878 18.29 17.958 17.43C18.058 16.19 17.468 15 16.288 14.05C15.618 13.52 14.838 13.1 13.988 12.79C16.198 12.15 18.978 12.58 20.688 13.96C21.608 14.7 22.078 15.63 21.988 16.59Z"
        fill="#C1C1C1"
      />
    </svg>
  );
};

export default Member;
